module.exports = require("./../../_gen/starling/events/TouchMarker");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/TouchMarker.js
// module id = 187
// module chunks = 0